/**
 * Órdenes anuladas (`status=anulada`). Reemplaza el placeholder de
 * `ROUTES.ordersCancelled`. Equivale a `cancelled_orders.html` del SSR.
 */
import { OrdersListScreen } from "./OrdersListScreen";

export function OrdersCancelledScreen() {
  return <OrdersListScreen status="anulada" title="Órdenes anuladas" />;
}
